import PropTypes from 'prop-types';
import { Box, Divider, Skeleton } from '@mui/material';

const FirmGuardrailsSkeleton = ({ showButton }) => (
	<Box
		data-testid='firm-guardrails-skeleton'
		sx={{
			backgroundColor: 'background.paper',
			border: '0.5px solid',
			borderColor: 'border.light',
			borderRadius: '8px',
			overflow: 'hidden',
		}}
	>
		<Box
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				gap: '16px',
				padding: '10px 12px',
			}}
		>
			<Box sx={{ flex: 1 }}>
				<Skeleton variant='text' width={190} height={20} />
				<Skeleton variant='text' width='60%' height={16} />
			</Box>

			{showButton && <Skeleton variant='rounded' width={100} height={30} />}
		</Box>

		<Divider />

		<Box sx={{ padding: '12px' }}>
			<Skeleton variant='rounded' width='100%' height={126} />

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					mt: '3px',
				}}
			>
				<Skeleton variant='text' width={45} height={18} />
			</Box>
		</Box>
	</Box>
);

FirmGuardrailsSkeleton.propTypes = {
	showButton: PropTypes.bool.isRequired,
};

export default FirmGuardrailsSkeleton;
